module.exports = __webpack_public_path__ + "img/idr.0b406ded.svg";